module.exports = __webpack_public_path__ + "img/wen-di@2x.925c5b82.png";